import {atom} from "jotai";

export const eventStatusClassAtom = atom([
    {
        status_name: "Scheduled",
        class: "bg-tl-scheduled"
    },
    {
        status_name: "Completed",
        class: "bg-tl-completed"
    },
    {
        status_name: "In Progress",
        class: "bg-tl-in-progress"
    },
    {
        status_name: "Needs Action",
        class: "bg-tl-failed"
    },
    {
        status_name: "Blocked Time",
        class: "bg-tl-other"
    },
    {
        status_name: "Time Off",
        class: "bg-tl-time-off"
    },
    {
        status_name: "En Route",
        class: "bg-tl-en-route"
    },
    {
        status_name: "Needs Remote Activation",
        class: "bg-tl-remote-activation"
    },
]);